import { Languages } from "waapi/front-utils/hooks/useTranslation/types.js";
import { LanguageSelect } from "../../containers/LanguageSelect/index.js";
import { StyledContainer } from "./style.js";

type FloatingLanguageSelectProps = {
    size?: "small" | "large";
    align?: "left" | "right";
    position?: "absolute" | "fixed";
    handleChange?: (newLanguage: Languages | undefined) => void;
};

export const FloatingLanguageSelect = ({
    size = "large",
    align = "left",
    position = "absolute",
    handleChange,
}: FloatingLanguageSelectProps): JSX.Element => {
    return (
        <StyledContainer align={align} position={position}>
            <LanguageSelect size={size} isFloating handleChange={handleChange} />
        </StyledContainer>
    );
};
